<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 15 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M5.3 10.9885L6.127 8.273L3.952 6.59625H6.65775L7.5 3.89225L8.34225 6.59625H11.048L8.85775 8.273L9.6845 10.9885L7.5 9.3L5.3 10.9885ZM2 19.7307V12.573C1.36667 11.9115 0.875 11.1468 0.525 10.2788C0.175 9.41092 0 8.48467 0 7.5C0 5.40767 0.726917 3.63458 2.18075 2.18075C3.63458 0.726916 5.40767 0 7.5 0C9.59233 0 11.3654 0.726916 12.8193 2.18075C14.2731 3.63458 15 5.40767 15 7.5C15 8.48467 14.825 9.41092 14.475 10.2788C14.125 11.1468 13.6333 11.9115 13 12.573V19.7307L7.5 17.9807L2 19.7307ZM7.5 13.5C9.16667 13.5 10.5833 12.9167 11.75 11.75C12.9167 10.5833 13.5 9.16667 13.5 7.5C13.5 5.83333 12.9167 4.41667 11.75 3.25C10.5833 2.08333 9.16667 1.5 7.5 1.5C5.83333 1.5 4.41667 2.08333 3.25 3.25C2.08333 4.41667 1.5 5.83333 1.5 7.5C1.5 9.16667 2.08333 10.5833 3.25 11.75C4.41667 12.9167 5.83333 13.5 7.5 13.5ZM3.5 17.5345L7.5 16.4615L11.5 17.5345V13.8193C10.9295 14.1911 10.3052 14.4808 9.627 14.6885C8.94867 14.8962 8.23967 15 7.5 15C6.76033 15 6.05133 14.8962 5.373 14.6885C4.69483 14.4808 4.0705 14.1911 3.5 13.8193V17.5345Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  name: 'BudgetTypeRecognition',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 15,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#62646A',
    },
  },
};
</script>
